import useAutoLoginFlow from './hooks/useAutoLoginFlow';
import useIdentifyCustomer from './hooks/useIdentifyCustomer';
import useHandleSocialCurrency from './hooks/useHandleSocialCurrency';
import useAttachUserConfigToWindow from './hooks/useAttachUserConfigToWindow';
import useHandleGenericQueryParams from './hooks/useHandleGenericQueryParams';
import useHandleUserSession from './hooks/useHandleUserSession';
import useCookieRewrite from './hooks/useCookieRewrite';
import useRedirectToGDPRPage from './hooks/useRedirectToGDPRPage';
import useSetSelectedCurrency from './hooks/useSetSelectedCurrency';
import useHandlePostVerifyEmail from './hooks/useHandlePostVerifyEmail';
import useSetUserTimezone from './hooks/useSetUserTimezone';

const UserProvider = ({ children }) => {
  useSetUserTimezone();
  useAttachUserConfigToWindow();
  useIdentifyCustomer();
  useAutoLoginFlow();
  useHandleSocialCurrency();
  useHandlePostVerifyEmail();
  useHandleGenericQueryParams();
  useHandleUserSession();
  useCookieRewrite();
  useRedirectToGDPRPage();
  useSetSelectedCurrency();

  return children;
};

export default UserProvider;
